module.exports = __webpack_public_path__ + "frontend/images/homepage/slider/card-2.jpg?3a909df81a4418c7202543318ca85f82";